import * as $ from "jquery";
import imkt from '../../../imkt';
import "waypoints/lib/jquery.waypoints.js";
import '@types/waypoints/jquery';

imkt.software.MobileMarketingPage = class MobileMarketingPage {
  constants = {
    SLIDESHOW_TEXT_CLASS: "slideshow-text",
    SLIDESHOW_IMAGE_CLASS: "slideshow-image",
    SLIDESHOW_ACTIVE_CLASS: "active",
    SLIDESHOW_TIMING: 4500, // 1000 equals 1 second
    SLIDESHOW_TIMING_START_DELAY: 3500, // 1000 equals 1 second
  };
  $domRoot: JQuery<HTMLElement>;
  $scrollTrigger: JQuery<HTMLElement>;
  $slideshowSection: JQuery<HTMLElement>;
  $slideshowImgColumn: JQuery<HTMLElement>;
  $slideshowImage: JQuery<HTMLElement>;
  $slideshowTextColumn: JQuery<HTMLElement>;
  $slideshowText: JQuery<HTMLElement>;
  slideshowActive: boolean;
  slideshowTimer: {};
  params: any;
  
  constructor(domRoot: HTMLElement, params: {}) {
    this.$domRoot = $("body");
    this.$scrollTrigger = $(".js-scrollTrigger", this.$domRoot);
    this.$slideshowSection = $(".mobile-slideshow-section");
    this.$slideshowImgColumn = $("#slideshowImgColumn", this.$slideshowSection);
    this.$slideshowImage = $(".slideshow-image", this.$slideshowImgColumn);
    this.$slideshowTextColumn = $("#slideshowTextColumn", this.$slideshowSection);
    this.$slideshowText = $(".slideshow-text", this.$slideshowTextColumn);

    this.slideshowActive = false;
    this.slideshowTimer = {};

    this.params = { ...params };

    this.init();
  }

  init() {
    if (this.$domRoot.hasClass("edit")) {
      return;
    }

    var self = this;

    $(document).on("imkt-svg-conversion-done", function () {
      self.bindEvents();
    });
  }

  bindEvents() {
    var self = this;

    // Scroll events
    this.$scrollTrigger.each(function () {
      var $el = $(this);
      $el.waypoint(
        function () {
          $el.addClass("active-in");

          // run function if slideshow section is triggered
          if ($el.is(self.$slideshowSection)) {
            // delay start
            setTimeout(function () {
              self.initSlideshow();
            }, self.constants.SLIDESHOW_TIMING_START_DELAY);
          }

          // remove handler after waypoint fires once
          this.destroy();
        },
        {
          offset: "50%",
        }
      );
    });

    // Click events
    this.$slideshowText.on("click", function (e) {
      self.triggerSlides(e.currentTarget);

      // stop slideshow when user interacts with elements
      if (self.slideshowActive) {
        self.stopSlideshow();
      }
    });
  }

  triggerSlides(target) {
    var $selection = $(target);
    var targetImageClass = $selection.attr("id");

    this.$slideshowText.removeClass(this.constants.SLIDESHOW_ACTIVE_CLASS);
    $selection.addClass(this.constants.SLIDESHOW_ACTIVE_CLASS);
    this.$slideshowImage.removeClass(this.constants.SLIDESHOW_ACTIVE_CLASS);
    this.$slideshowImgColumn
      .find("." + targetImageClass)
      .addClass(this.constants.SLIDESHOW_ACTIVE_CLASS);
  }

  initSlideshow() {
    var self = this;
    self.slideshowActive = true;

    this.slideshowTimer = setInterval(function () {
      var nextActive = self.$slideshowTextColumn
        .find("." + self.constants.SLIDESHOW_ACTIVE_CLASS)
        .next("." + self.constants.SLIDESHOW_TEXT_CLASS);

      if (nextActive.length > 0) {
        self.triggerSlides(nextActive);
      } else {
        self.triggerSlides(
          self.$slideshowTextColumn.children(self.$slideshowText).first()
        );
      }
    }, this.constants.SLIDESHOW_TIMING);
  }

  stopSlideshow() {
    clearInterval(this.slideshowTimer);
    this.slideshowActive = false;
  }
}

// document ready
$(function () {
  new imkt.software.MobileMarketingPage();
});
